export interface IUser {
    id: string
    email: string
    full_name: string
    city: string
    address: string
    phone_number: string
    created_at: string
    gender: string
    is_admin: boolean
    points: number
    available_points: number
    profile_picture: string
    default_locale: string
    has_spin_today: string | null
    subscribed: boolean
}

export interface IUsersResponse {
    total_pages: number
    count: number
    data: IUser[]
}

interface Points {
    date: string
    change: string
    type: "wheel_spins" | "draw" | "voucher",
    recipient_email: string | null
    wish_name_en: string | null
    wish_name_mk: string | null
    wish_name_al: string | null
    wish_option_name_en: string | null
    wish_option_name_mk: string | null
    wish_option_name_al: string | null

    [key: string]: any
}

export interface PointsHistoryResponse {
    count: number
    points: Points[]
}

export interface IUserState {
    loading: boolean
    items: IUsersResponse
    previousLeaderboard: IPreviousLeaderboard[]
    buyGiftCouponLoading: boolean
    pointsHistoryLoading: boolean
    pointsHistory: PointsHistoryResponse
}

export const initialUsersState: IUsersResponse = {
    total_pages: 0,
    count: 0,
    data: []
}

export interface IPreviousLeaderboard {
    full_name: string
    points: number
    profile_picture: string | null
    title_en: string | null
    title_mk: string | null
    title_al: string | null
    prize_url: string | null
    year_month: string

    [key: string]: any
}